import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { login } from "../../actions/userActions";
import Loader from "../main/Loader";
import Message from "../main/Message";

function LoginCheckout() {
  // Selectors
  const userLogin = useSelector((state) => state.userLogin);
  const { error, loading, userInfo } = userLogin;

  // Dispatch and Navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // State Etc
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const redirect = "/checkout/billing-info";

  // useEffects
  useEffect(() => {
    if (userInfo) {
      navigate(redirect, { replace: true });
    }
  }, [navigate, userInfo, redirect]);

  // Submit
  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  // Navs and Footer
  useEffect(() => {
    const nav = document.querySelector(".navigation-large");
    nav.className =
      "navigation-large d-none d-md-flex justify-content-between fixed-top section-bg";
  }, []);

  useEffect(() => {
    const nav = document.querySelector(".navigation-small");
    nav.className =
      "navigation-small d-flex justify-content-between d-md-none fixed-top section-bg";
  }, []);

  useEffect(() => {
    const footer = document.querySelector(".footer-contain");
    footer.className = "footer-contain section-bg";
  }, []);

  return (
    <Container className="section-contain">
      {loading ? (
        <Loader />
      ) : (
        <>
          {error && (
            <Row className="message-contain">
              <Col md={12}>
                <Message variant="danger">{error}</Message>
              </Col>
            </Row>
          )}
          <Form onSubmit={submitHandler}>
            <Row>
              <Col md={12}>
                <h1 className="header">Log In</h1>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder=""
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder=""
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={12} className="form-link">
                <Button type="submit" variant="primary">
                  Log in
                </Button>
              </Col>
              <Col md={12} className="mt-3 form-link">
                <Link to="/register">Create a new account</Link>
              </Col>
              <Col md={12} className="form-link">
                <Link to="/reset-request">Forget your password?</Link>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </Container>
  );
}

export default LoginCheckout;
